var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.AzurePowerShell", function() {
    return {
      executionLocation: actionExecutionLocations.alwaysOnServer,
      canChooseRoles: true,
      canHaveChildren: function() { return false; },
      canBeChild: true,
      hasPackages: function(action) { return false; },

            summaryTemplateUrl: "areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_summary.html",
            editTemplateUrl: "areas/projects/actions/azure_powershell/Octopus.AzurePowerShell_edit.html",

            preLink: function (scope) {
                scope.account = {};

                scope.getAccountId = function () {
                    return (scope.action) ? scope.action.Properties['Octopus.Action.Azure.AccountId'] : undefined;
                };
            },

            editLink: function (scope) {

                scope.account.AccountId = scope.action.Properties["Octopus.Action.Azure.AccountId"];

                scope.$watch(function () {
                        return scope.account.AccountId;
                    },
                    function () {
                        if (scope.action) {
                            scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
                        }
                    });

                scope.$watch('action.Properties', function (nv) {
                    if (nv != null) {
                        if (!nv['Octopus.Action.Script.ScriptSource']) {
                            nv['Octopus.Action.Script.ScriptSource'] = "Inline";
                        }

                        var isRunFromPackage = nv['Octopus.Action.Script.ScriptSource'] === 'Package';
                        if (isRunFromPackage) {
                            nv['Octopus.Action.Script.ScriptBody'] = null;
                        } else {
                            nv['Octopus.Action.Script.ScriptFileName'] = null;
                            nv['Octopus.Action.Package.FeedId'] = null;
                            nv['Octopus.Action.Package.PackageId'] = null;
                        }
                    }
                }, true);
            }
        };
    });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_powershell/Octopus.AzurePowerShell.js
// module id = 487
// module chunks = 1